import { Theme, withStyles } from '@material-ui/core'
import classNames from 'classnames'
import { MuiClasses } from '../../types'

const styles = ({ breakpoints, spacing }: Theme) => ({
  container: {
    boxSizing: 'border-box' as const,
    padding: spacing(2),
    [breakpoints.down('sm')]: {
      padding: spacing(1)
    }
  },

  center: {
    textAlign: 'center' as any
  }
})

type ContainerProps = {
  children: any
  classes: MuiClasses
  alignCenter: boolean
  className?: string
  styles?: any
}

const Container = ({
  children,
  classes,
  alignCenter,
  className,
  styles
}: ContainerProps) => {
  return (
    <div
      style={styles}
      className={classNames(
        classes.container,
        { [classes.center]: alignCenter },
        className
      )}
    >
      {children}
    </div>
  )
}

export default withStyles(styles)(Container as any)
